function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M423.924,179.861c0-0.6,0-1.2,0-1.8c0.042-75.111-60.813-136.034-135.923-136.077 c-45.695-0.026-88.348,22.898-113.541,61.021C124.115,86.198,69.677,113.386,52.87,163.731c-3.265,9.779-4.935,20.02-4.945,30.33 c0,0.68,0,1.368,0,2.056c-34.211,8.887-54.74,43.825-45.853,78.035c7.32,28.179,32.738,47.867,61.853,47.909h143.464 c4.418,0,8-3.582,8-8s-3.582-8-8-8H63.924c-26.509-0.158-47.871-21.775-47.714-48.284c0.141-23.766,17.653-43.85,41.178-47.228 c4.229-0.569,7.266-4.357,6.904-8.608c-0.216-2.576-0.368-5.224-0.368-7.88c0.052-44.236,35.955-80.054,80.19-80.001 c10.494,0.012,20.883,2.087,30.578,6.105c3.673,1.526,7.91,0.122,9.944-3.296c33.737-57.044,107.33-75.939,164.375-42.201 c36.547,21.615,58.951,60.933,58.913,103.393c0,2.648-0.064,5.216-0.288,7.792c-0.371,4.301,2.737,8.121,7.024,8.632 c30.694,3.798,52.497,31.759,48.7,62.453c-3.465,28.002-27.221,49.052-55.436,49.123H271.636c-4.418,0-8,3.582-8,8s3.582,8,8,8 h136.288c39.765,0.001,72.001-32.234,72.001-71.999C479.926,216.461,456.685,187.327,423.924,179.861z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M313.46,259.401c2.994-3.1,2.994-8.015,0-11.116l-67.88-67.88c-3.124-3.123-8.188-3.123-11.312,0l-67.88,67.88 c-3.07,3.178-2.982,8.243,0.196,11.312c3.1,2.994,8.015,2.994,11.116,0l54.224-54.224v224.568c0,4.418,3.582,8,8,8s8-3.582,8-8 V205.373l54.224,54.224C305.326,262.666,310.391,262.579,313.46,259.401z"
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgImport = function SvgImport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 479.925 479.925",
    style: {
      enableBackground: "new 0 0 479.925 479.925"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/import.324b29a1.svg";
export { ForwardRef as ReactComponent };